import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router'
import { NotificationsService } from 'angular2-notifications';

import { ExibirMenuService } from '../shared/exibir-menu.service'
import { DadosAcessoService } from '../../dadosAcesso.service'
import { AcessoApiService } from '../../acessoApi.service'
import { isNullOrUndefined } from 'util';
declare var $: any


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public mostraMenu: boolean
  private image: any
  public idFoto: any = '1'
  public idNoticia: any
  public tituloNot: string
  public manchete: string
  public urlNot: string
  public urlBlog: string
  public textoInserir: string = "Inserir Noticia";
  public textoEditar: string = "Editar Postagem";
  public textoEditarMensagem: string = "Editar Mensagem";


  constructor(private exibirItens: ExibirMenuService, private elem: ElementRef, private dadosAcesso: DadosAcessoService, private router: Router, private acessoAPI: AcessoApiService, private notificacao: NotificationsService) {
    if (sessionStorage.getItem('cod_loja') === null) {

      this.router.navigate(["/"])
    }



    this.exibirItens.setItensVisiveis(true);

  }

  ngOnInit() {

  }
  public preparaImagemUpload(event: Event): void {
    this.image = (<HTMLInputElement>event.target).files;
  }


  enviarImagem() {
    let files = this.elem.nativeElement.querySelector('#selectFile').files;
    let formData = new FormData();
    let file = files[0];
    formData.append('file', file, "imagem" + this.idFoto + ".jpg");
    this.acessoAPI.uploadImage(formData, this.idFoto).subscribe(data => {

      this.acessoAPI.editarUltimaBlog(this.idFoto, this.manchete, this.urlBlog).subscribe(data => {
        $("#modalEditarUltimas").modal('hide');
        this.textoEditar = "Editar Postagem";

        this.notificacao.success(
          'Sucesso!',
          'Dados Modificados com sucesso!',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

      }, error => {
        this.textoEditar = "Editar Postagem";

      })

    }, error => {
      this.textoEditar = "Editar Postagem";

    });
  }

  getUrl(url: Event) {
    this.urlNot = ((<HTMLInputElement>url.target).value)
  }

  getTitulo(titulo: Event) {
    this.tituloNot = ((<HTMLInputElement>titulo.target).value)

  }

  getNumeroFoto(idFoto) {
    this.idFoto = idFoto.value

  }

  getManchete(manchete: Event) {
    this.manchete = ((<HTMLInputElement>manchete.target).value)

  }

  getURLBlog(urlBlog: Event) {
    this.urlBlog = ((<HTMLInputElement>urlBlog.target).value)
  }



  editarUltima() {
    this.textoEditar = "Editando...";

    if (this.manchete === "" || this.manchete === undefined) {
      this.notificacao.error(
        'Campo em branco!',
        'Favor preencher a manchete!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
      this.textoEditar = "Editar Postagem";

    } else if (this.urlBlog === "" || this.urlBlog === undefined) {
      this.notificacao.error(
        'Campo em branco!',
        'Favor preencher a URL!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
      this.textoEditar = "Editar Postagem";

    } else {
      this.enviarImagem()
    }
  }

  enviarNoticia() {
    this.textoInserir = "Inserindo...";
    if (this.tituloNot === "" || this.tituloNot === undefined) {

      this.textoInserir = "Inserir Noticia";
      this.notificacao.error(
        'Campo em branco!',
        'Favor preencher o titulo!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    } else {

      this.acessoAPI.inserirNovaMensagem(this.tituloNot, this.urlNot).subscribe(data => {
        this.notificacao.success(
          'Noticia Incluida!',
          'Sua notícia foi acrescentada com sucesso',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

        this.urlNot = ""
        this.tituloNot = ""
        this.textoInserir = "Inserir Noticia";


        $("#modalIncluirMensagem").modal('hide');


      }, error => {
        this.notificacao.error(
          'Erro ao inserir!',
          'Ocorreu um erro ao inserir notícia!',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )
        this.textoInserir = "Inserir Noticia";

      })

    }

  }

  editarNoticia():any{
    this.textoEditarMensagem = "Editando..."
    this.idNoticia = this.dadosAcesso.recuperarIDNOT();
    if(isNullOrUndefined(this.urlNot) && isNullOrUndefined(this.tituloNot)){
      this.notificacao.error(
        'Erro ao Editar!',
        'Preencha um dos campos para prosseguir!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
      this.textoEditarMensagem = "Editar Mensagem"
    }else{
        this.acessoAPI.PostAlteraMensagem(this.idNoticia, this.urlNot, this.tituloNot).subscribe(data =>{
          this.notificacao.success(
            'Noticia Alterada!',
            'Sua notícia foi alterada com sucesso',
            {
              timeOut: 2000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }
          )
      this.textoEditarMensagem = "Editar Mensagem"
          
        $("#modalEditarMensagem").modal('hide');
        this.urlNot = ""
        this.tituloNot = ""
          
        }, error =>{
          this.notificacao.error(
            'Erro ao Editar!',
            'Ocorreu um erro de comunicação com o servidor!',
            {
              timeOut: 2000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }
          )
      this.textoEditarMensagem = "Editar Mensagem"
          
        })
      }
    
    
  }



}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts